import gql from 'graphql-tag';

export const UpdateIncidentCategory = gql`
  mutation UpdateIncidentCategory(
    $organizationId: ID!
    $categoryId: ID!
    $request: UpdateIncidentCategoryRequest!
  ) {
    updateIncidentCategory(organizationId: $organizationId, categoryId: $categoryId, request: $request) {
      id
      name
      color
    }
  }
`;
